export const formatSettingsValue = (value: string | number) =>
  Number(
    String(value)
      .replace(',', '.')
      .replace(/[^\d.]/g, '')
  ) || 0;

export const validateSettingsValue = (
  value: string | number,
  from: number,
  to: number,
  integer?: boolean
) => {
  const formattedValue = formatSettingsValue(value);

  if (isNaN(formattedValue)) {
    return false;
  }

  if (integer) {
    return (
      Number.isInteger(formattedValue) &&
      formattedValue >= from &&
      formattedValue <= to
    );
  }

  return formattedValue >= from && formattedValue <= to;
};
